import React, { useState, useEffect } from "react";
import {
  Form,
  Toast,
  Button,
  Row,
  InputGroup,
  Image,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isEmpty } from "lodash";
import {
  AddPlans,
  LoaderWrapper,
  SliderPanel,
  Link,
  FormControlSearch,
  DeleteWarning,
  WarningModal,
  AddToolTip,
} from "../../../components";
import { useDeepEffect, useRequest } from "../../../abstracts";
import { getPlanGroupsWithoutCount } from "../../../services";
import SearchBar from "../../Mapper/LoadDefHomeContainer/SearchBar";

export const PlanGroupInformation = (props) => {
  const {
    planGroupMappings,
    setPlanGroupMappings,
    isSave,
    isEdit,
    savedPlanGroups,
    setsavedPlanGroups,
    initialSavedPlanGroups,
    setInitialSavedPlanGroups,
    planGroupList,
  } = props;

  const [isModalOpen, setModalOpen] = useState(false);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [addedPlanGroups, setaddedPlanGroups] = useState([]);
  const [searchaddedPlanGroups, setSearchaddedPlanGroups] = useState("");
  const [searchSavedPlanGroups, setsearchSavedPlanGroups] = useState("");
  const [searchPlanGroupList, setsearchPlanGroupList] = useState("");
  const [addedPlanGroupsFilter, setaddedPlanGroupsFilter] = useState([]);
  const [savedPlanGroupsFilter, setsavedPlanGroupsFilter] = useState([]);
  const [planGroupListFilter, setplanGroupListFilter] = useState([]);
  const [showRemoveWarning, setShowRemoveWarning] = useState(false);

  const [planGroups, setPlanGroups] = useState([]);

  useDeepEffect(() => {
    setaddedPlanGroups(savedPlanGroups);
    // setPlanGroups(
    //   planGroupList.filter(
    //     (plan) =>
    //       !savedPlanGroups.map((planGroup) => planGroup.id).includes(plan.id)
    //   )
    // );
  }, [savedPlanGroups]);
  useDeepEffect(() => {
    setPlanGroups(
      planGroupList?.filter(
        (plan) =>
          !savedPlanGroups.map((planGroup) => planGroup.id).includes(plan.id)
      )
    );
  }, [planGroupList]);

  const addPlansToPlanGroup = (name) => {
    var t = planGroups.filter((e) => e.id === name.id);
    var mapVaule = {
      id: t[0].id,
      name: t[0].name,
      description: t[0].description,
      planGroupId: t[0].id,
    };
    setaddedPlanGroups((e) => [mapVaule, ...e]);
    var temp = planGroups.filter((e) => e.id !== name.id);
    setPlanGroups(temp);
  };

  useDeepEffect(
    () => {
      let apiPlans = planGroupList.filter((planGroup) =>
        planGroupMappings.map((item) => item.planGroupId).includes(planGroup.id)
      );
      const apiPlans1 = apiPlans.map((item) => {
        planGroupMappings.map((mapping) => {
          if (item.id === mapping.planGroupId) {
            item["mapId"] = mapping.id;
          }
        });
        return item;
      });
      setsavedPlanGroups(apiPlans1);
      setaddedPlanGroups(apiPlans1);

      if (!isEmpty(planGroupMappings)) {
        setPlanGroups(
          planGroupList.filter(
            (planGroup) =>
              !planGroupMappings
                .map((item) => item.planGroupId)
                .includes(planGroup.id)
          )
        );
      } else {
        setPlanGroups(planGroupList);
      }
    },
    [planGroupMappings],
    [planGroupList]
  );

  const onViewButtonClick = () => {
    setModalOpen(true);
  };

  const onViewPlanCountClick = () => {
    setSliderOpen(true);
  };
  const onSubmit = (plans) => {
    setPlanGroupMappings(plans);
    setInitialSavedPlanGroups(plans);
    setsavedPlanGroups(plans);
    setModalOpen(false);
  };

  const onCancel = () => {
    setaddedPlanGroups(savedPlanGroups);
    setPlanGroupMappings(savedPlanGroups);
    setPlanGroups(
      planGroupList.filter(
        (plan) =>
          !savedPlanGroups.map((planGroup) => planGroup.id).includes(plan.id)
      )
    );
    setModalOpen(false);
  };

  const addAllPlans = () => {
    var mappedValue = planGroupListFilter.map((data) => {
      return (data = {
        ...data,
        id: data.id,
        name: data.name,
        description: data.description,
        planGroupId: data.id,
      });
    });
    setaddedPlanGroups((e) => [...mappedValue, ...e]);
    setPlanGroups([]);
  };

  const removeAllPlans = () => {
    setPlanGroups([...addedPlanGroups, ...planGroups]);

    setaddedPlanGroups([]);
  };

  useDeepEffect(() => {
    setsavedPlanGroupsFilter(savedPlanGroups);
  }, [savedPlanGroups]);

  useDeepEffect(() => {
    let x = planGroups.filter(
      (o1) => !addedPlanGroups.some((o2) => o1.id === o2.planGroupId)
    );
    setplanGroupListFilter(x);
  }, [planGroups]);

  useDeepEffect(() => {
    setaddedPlanGroupsFilter(addedPlanGroups);
  }, [addedPlanGroups]);

  useDeepEffect(() => {
    setaddedPlanGroupsFilter(
      addedPlanGroups.filter((team) => {
        return team.name
          .toLowerCase()
          .includes(searchaddedPlanGroups.toLowerCase());
      })
    );
  }, [searchaddedPlanGroups]);
  useDeepEffect(() => {
    if (searchSavedPlanGroups !== "") {
      setsavedPlanGroupsFilter(
        savedPlanGroups?.filter((team) => {
          return (
            team.name
              .toLowerCase()
              .includes(searchSavedPlanGroups.toLowerCase()) ||
            (team.description != undefined &&
              team.description
                .toLowerCase()
                .includes(searchSavedPlanGroups.toLowerCase()))
          );
        })
      );
    } else {
      setsavedPlanGroupsFilter(savedPlanGroups);
    }
  }, [searchSavedPlanGroups]);

  useDeepEffect(
    () => {
      setplanGroupListFilter(
        planGroups.filter((team) => {
          return team.name
            .toLowerCase()
            .includes(searchPlanGroupList.toLowerCase());
        })
      );
    },
    [searchPlanGroupList],
    [planGroups]
  );

  const removePlansFromPlanGroup = (name) => {
    var temp = addedPlanGroups.filter(
      (e) => e.planGroupId !== name.planGroupId
    );
    setaddedPlanGroups(temp);
    setPlanGroups((e) => [name, ...e]);
  };

  const savedPlanGroupsLength = () => {
    if (savedPlanGroups.length < 9) {
      return `0${savedPlanGroups.length}`;
    } else {
      return savedPlanGroups.length;
    }
  };

  const handleConfirmClick = () => {
    onSubmit(planGroupMappings);
    setsavedPlanGroups(planGroupMappings);
    setaddedPlanGroups(planGroupMappings);
    setShowRemoveWarning(false);
    setInitialSavedPlanGroups(planGroupMappings);
  };
  const handleCancelClick = () => {
    setShowRemoveWarning(false);
  };
  return (
    <div>
      {isEmpty(savedPlanGroups) ? (
        <div>
          <LoaderWrapper>
            <AddPlans
              menu="plan"
              subMenu="basicDetails"
              content="No plan group have been setup for this plan"
              buttonLabel="Add Plan Groups"
              onPrimaryClick={onViewButtonClick}
              disabled={isEdit && !isSave}
            />
          </LoaderWrapper>
        </div>
      ) : (
        <div>
          <LoaderWrapper>
            <AddPlans
              menu="plan"
              subMenu="basicDetails"
              content={
                <div>
                  {" "}
                  <i class="pad-left fal fa-file-invoice-dollar pad-right-13 pad-top-6 ft-18"></i>
                  <Link
                    onClick={() => {
                      onViewPlanCountClick();
                    }}
                    style={{ color: "royalblue" }}
                  >
                    {" "}
                    {savedPlanGroupsLength()}
                  </Link>{" "}
                  Plan Groups Mapped
                </div>
              }
              buttonLabel="Add / Remove Plan Groups"
              onPrimaryClick={onViewButtonClick}
              disabled={isEdit && !isSave}
            />
          </LoaderWrapper>
        </div>
      )}

      <SliderPanel
        showHeader={true}
        header={"Added plan groups"}
        isOpen={isSliderOpen}
        size="35"
        showCancel={true}
        onClose={() => {
          setSliderOpen(false);
          setsearchSavedPlanGroups("");
        }}
      >
        <div className="d-flex justify-content-between align-baseline">
          <div>
            {/* <p className="plan-group-plan-add">Added plan groups</p> */}
            <p className="plan-count-sub-heading">
              {savedPlanGroups.length} Plan Groups Found
            </p>
          </div>
        </div>
        {/* <div style={{ width: "453px" }}> */}
        <div>
          <Form>
            <InputGroup>
              <InputGroup.Prepend>
                <div className="search-icon-postion">
                  <i class="fal fa-search" aria-hidden="true"></i>
                </div>
              </InputGroup.Prepend>
              <FormControlSearch
                size="md"
                type="search"
                className="pad-left-search"
                placeholder="Search plan group name & description"
                onChange={(e) => setsearchSavedPlanGroups(e.target.value)}
              />
            </InputGroup>
          </Form>
        </div>

        <div className="Added-plan-basic-tiles">
          {savedPlanGroupsFilter.map((data, index) => (
            <Row>
              <div className="tile-plan-group w-453 ">
                <div className="tile-text" style={{ marginLeft: "20px" }}>
                  <div className="tile-title w-269">
                    {data.name.length > 35 ? (
                      <AddToolTip name={data.name} placement="bottom">
                        {(data.name || "").slice(0, 25)}...
                      </AddToolTip>
                    ) : (
                      <div> {data.name}</div>
                    )}
                  </div>
                  <div className="tile-number">
                    {data.description?.length > 35 ? (
                      <AddToolTip name={data.description} placement="bottom">
                        {(data.description || "").slice(0, 25)}...
                      </AddToolTip>
                    ) : (
                      <div> {data.description}</div>
                    )}
                  </div>
                </div>
              </div>
            </Row>
          ))}
        </div>
      </SliderPanel>

      <SliderPanel
        screen="plan-group"
        isOpen={isModalOpen}
        size="70"
        showCancel={false}
      >
        <div className="w-100 maintenance-container">
          <div className="Add-plans-header-basic">
            <div className="ft-18 plan-group-title">
              Add Plan Group Information
            </div>
            <div>
              <Button
                variant="secondary"
                onClick={() => {
                  if (
                    JSON.stringify(initialSavedPlanGroups) ===
                    JSON.stringify(
                      !isEmpty(addedPlanGroups)
                        ? addedPlanGroups
                        : savedPlanGroups
                    )
                  ) {
                    onCancel();
                  } else {
                    setShowRemoveWarning(true);
                  }
                }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => onSubmit(addedPlanGroups)}
                className="ml-4"
              >
                Save
              </Button>
            </div>
          </div>

          <div className="add-plans-content">
            <div
              className="left-basic-plan w-50 height-80 "
              style={{ overflowY: "scroll" }}
            >
              <div className="left-2-basic-plan w-100">
                <div className="marg-left-13">
                  <div className="plan-group-plan-add">
                    Plan groups information
                  </div>
                  <div className="marg-bot-15 max-width-381 w-100">
                    <Form>
                      <InputGroup>
                        <div className="search-icon-postion">
                          <i class="fal fa-search" aria-hidden="true"></i>
                        </div>
                        <SearchBar
                          size="md"
                          type="search"
                          placeholder="Search plan group name"
                          className="pad-left-search"
                          onChange={(e) =>
                            setsearchPlanGroupList(e.target.value)
                          }
                        />
                      </InputGroup>
                    </Form>
                  </div>
                </div>
                <div className="small-options w-100 justify-content-between">
                  <div className="small-text w-310">
                    {planGroupListFilter.length} Plan groups
                  </div>
                  <div className="small-text marg-right-18">
                    <Link
                      className="link primary-small"
                      onClick={() => addAllPlans()}
                    >
                      Add all
                    </Link>
                  </div>
                </div>

                <div
                  className="Add-plan-tiles w-100"
                  style={{
                    height: "420px",
                  }}
                >
                  {planGroupListFilter?.map((data, index) => (
                    <Row>
                      <div className="tile-plan-group w-90 justify-content-between marg-left-20 marg-right-20">
                        <div className="tile-text pad-left-15">
                          <div className="tile-title w-342">
                            {data.name.length > 35 ? (
                              <AddToolTip name={data.name} placement="bottom">
                                {(data.name || "").slice(0, 25)}...
                              </AddToolTip>
                            ) : (
                              <div> {data.name}</div>
                            )}
                          </div>
                          <div className="tile-number">
                            {data.description?.length > 35 ? (
                              <AddToolTip
                                name={data.description}
                                placement="bottom"
                              >
                                {(data.description || "").slice(0, 25)}...
                              </AddToolTip>
                            ) : (
                              <div> {data.description}</div>
                            )}
                          </div>
                        </div>
                        <Link>
                          <div className="Arrow">
                            <i
                              className="fa fa-long-arrow-right"
                              aria-hidden="true"
                              onClick={() => addPlansToPlanGroup(data)}
                            ></i>
                          </div>
                        </Link>
                      </div>
                    </Row>
                  ))}
                </div>
              </div>
            </div>

            <div className="basic-plan-details-right w-50 height-80">
              <div className="basic-plan-details-right-1 w-100 h-90 ">
                <div className="plan-group-plan-add">Added plan groups</div>
                {/* <div style={{ width: "453px" }}> */}
                <div className="w-100">
                  <Form>
                    <InputGroup>
                      <div className="search-icon-postion">
                        <i class="fal fa-search" aria-hidden="true"></i>
                      </div>
                      <SearchBar
                        size="md"
                        type="search"
                        placeholder="Search plan group name"
                        className="pad-left-search"
                        onChange={(e) =>
                          setSearchaddedPlanGroups(e.target.value)
                        }
                      />
                    </InputGroup>
                  </Form>
                </div>
                <div className="plan-group-remove-count w-100">
                  <div className="plan-group-remove">
                    <Link
                      className="link red-small"
                      onClick={() => removeAllPlans()}
                    >
                      Remove all
                    </Link>
                  </div>
                  {addedPlanGroupsFilter.length == 1 ? (
                    <div className="plan-group-plan">
                      {addedPlanGroupsFilter.length} Plan group
                    </div>
                  ) : (
                    <div className="plan-group-plan">
                      {addedPlanGroupsFilter.length} Plan groups
                    </div>
                  )}
                </div>

                {isEmpty(addedPlanGroups) ? (
                  <div className="plan-group-no-plan">
                    <div className="plan-no-plan">No plan groups added</div>
                    <div className="plan-add-plan">
                      Please add plan groups here by clicking on the arrow
                    </div>
                  </div>
                ) : (
                  <div
                    className="basic-added-plan w-100 height-80"
                    //style={{ paddingRight: "20px" }}
                  >
                    {addedPlanGroupsFilter.map((data, index) => (
                      <Row className="w-100">
                        <div className="tile-added-plan-group w-100  marg-left-15">
                          <Link>
                            <div className="Arrow">
                              <i
                                className="fa fa-long-arrow-left"
                                aria-hidden="true"
                                onClick={() => removePlansFromPlanGroup(data)}
                              ></i>
                            </div>
                          </Link>
                          <div className="tile-text-added w-342 pad-right-15">
                            <div className="tile-title">
                              {data.name.length > 35 ? (
                                <AddToolTip name={data.name} placement="bottom">
                                  {(data.name || "").slice(0, 25)}...
                                </AddToolTip>
                              ) : (
                                <div> {data.name}</div>
                              )}
                            </div>
                            <div className="tile-number">
                              {data.description?.length > 35 ? (
                                <AddToolTip
                                  name={data.description}
                                  placement="bottom"
                                >
                                  {(data.description || "").slice(0, 25)}...
                                </AddToolTip>
                              ) : (
                                <div> {data.description}</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </Row>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <WarningModal
          show={showRemoveWarning}
          onHide={() => showRemoveWarning(false)}
        >
          <div className="remove-text">
            <h4>Are you sure?</h4>
            <p>Your changes may be lost. Do you want to continue?</p>
            <Button
              type="button"
              className="remove-btn mr-4"
              onClick={() => handleConfirmClick()}
            >
              Yes
            </Button>
            <Button className="cancel-btn" onClick={() => handleCancelClick()}>
              No
            </Button>
          </div>
        </WarningModal>
      </SliderPanel>
    </div>
  );
};

export default PlanGroupInformation;
